import Schema from "../details/validation";
import { getColumnSize } from "modules/common/services/table/size-storage";
import { getFieldLabel } from "modules/common/services/form/fields";
import { fields } from "../../models/bank-details";
import { ColDef } from "@ag-grid-community/core";
import { RowNumberColumn } from "modules/common/services/table/helpers";

const schema = Schema();

export const columns = (tableName: string) => {
    const columnSize = getColumnSize(tableName);

    const result: ColDef[] = [
        RowNumberColumn(false, ""),
        {
            headerName: getFieldLabel(fields.name, schema, null),
            field: fields.name,
            width: columnSize(fields.name, 350),
            sortable: true,
            resizable: true,
        },
        {
            headerName: "Основные",
            field: fields.main,
            width: columnSize(fields.name, 50),
            sortable: true,
            resizable: true,
            valueFormatter: ({ value }) => {
                return value ? "Да" : "";
            },
        },
        {
            headerName: getFieldLabel(fields.bankName, schema, null),
            field: fields.bankName,
            width: columnSize(fields.bankName, 450),
            sortable: true,
            resizable: true,
        },
        {
            headerName: getFieldLabel(fields.account, schema, null),
            field: fields.account,
            width: columnSize(fields.account, 300),
            sortable: true,
            resizable: true,
        },
        {
            headerName: getFieldLabel(fields.comment, schema, null),
            field: fields.comment,
            flex: 1,
            sortable: false,
            resizable: false,
        },
    ];

    return result;
};
